<template>
  <div class="admin-preguntas-container">
    <CardPrime class="admin-preguntas-card">
      <template #title>
        <div class="card-header">
          <h3 class="card-title">Administración de Preguntas</h3>
          <ButtonPrime 
            label="Nueva Pregunta" 
            icon="pi pi-plus" 
            class="p-button-primary p-button-sm" 
            @click="irANuevaPregunta" 
          />
        </div>
      </template>
      <template #content>
        <EmailSearch v-model="filters['global'].value" @search-results="updatePreguntas" />
        <PreguntaTable 
          :preguntas="preguntas" 
          :rows="lazyParams.rows"
          :totalRecords="totalRecords" 
          :filters="filters"
          :loading="loading" 
          @page="onPage"
          @editarPregunta="editarPregunta"
        />
      </template>
    </CardPrime>

    <PreguntaDialog 
      :visible="preguntaDialog" 
      :pregunta="pregunta" 
      :cerrarDialog="cerrarDialog" 
      :guardarPregunta="guardarPregunta" 
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

import { FilterMatchMode } from 'primevue/api';
import preguntaService from '@/services/PreguntaService';
import EmailSearch from '@/components/pregunta/SearchComp.vue'; // Asegúrate de que este componente exista
import PreguntaTable from '@/components/pregunta/PreguntaTable.vue'; // Asegúrate de que este componente exista
import PreguntaDialog from '@/components/pregunta/PreguntaDialog.vue'; // Asegúrate de que este componente exista

export default {
  components: {
    EmailSearch,
    PreguntaTable,
    PreguntaDialog
  },
  setup() {

    const preguntas = ref([]);
    const pregunta = ref({});
    const preguntaDialog = ref(false);
    const totalRecords = ref(0);
    const loading = ref(false);
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'Texto': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const lazyParams = ref({
      first: 0,
      rows: 20,
      page: 1,
      filters: filters.value
    });

    const cargarPreguntas = async () => {
      loading.value = true;
      try {
        const response = await preguntaService.get(lazyParams.value.page || 1, lazyParams.value.rows || 20);
        preguntas.value = response.data.Content; // Asegúrate de que la estructura de respuesta sea correcta
        totalRecords.value = response.data.TotalRecords; // Asegúrate de que la estructura de respuesta sea correcta
      } catch (error) {
        console.error('Error al cargar preguntas:', error);
      } finally {
        loading.value = false;
      }
    };

    const updatePreguntas = (resultados) => {
      preguntas.value = resultados; // Actualiza la lista de preguntas con los resultados de búsqueda
      totalRecords.value = resultados.length; // Actualiza el total de registros
    };

    const onPage = (event) => {
      lazyParams.value = {
        ...lazyParams.value,
        first: event.first,
        rows: event.rows,
        page: Math.floor(event.first / event.rows) + 1
      };
      cargarPreguntas();
    };

    const irANuevaPregunta = () => {
      pregunta.value = {}; // Limpia el objeto pregunta para crear una nueva
      preguntaDialog.value = true; // Abre el diálogo para crear una nueva pregunta
    };

    const editarPregunta = (data) => {
      pregunta.value = { ...data }; // Carga la pregunta seleccionada para editar
      preguntaDialog.value = true; // Abre el diálogo para editar la pregunta
    };

    const cerrarDialog = () => {
      preguntaDialog.value = false; // Cierra el diálogo
      pregunta.value = {}; // Limpia el objeto pregunta
    };

    const guardarPregunta = async () => {
      try {
        if (pregunta.value.id) {
          await preguntaService.actualizar(pregunta.value.id, pregunta.value); // Actualiza la pregunta
        } else {
          await preguntaService.crear(pregunta.value); // Crea una nueva pregunta
        }
        cerrarDialog();
        cargarPreguntas(); // Recarga la lista de preguntas
      } catch (error) {
        console.error('Error al guardar pregunta:', error);
      }
    };

    onMounted(() => {
      cargarPreguntas(); // Carga las preguntas al montar el componente
    });

    return {
      preguntas,
      pregunta,
      preguntaDialog,
      totalRecords,
      loading,
      filters,
      lazyParams,
      onPage,
      irANuevaPregunta,
      editarPregunta,
      cerrarDialog,
      guardarPregunta,
      updatePreguntas
    };
  }
}
</script>

<style scoped>
.admin-preguntas-container {
  padding: 1rem;
}

.admin-preguntas-card {
  background: var(--surface-card);
  border-radius: var(--border-radius);
  padding: 1rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.card-title {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-color);
}
</style>